import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Table
} from "reactstrap"
import { Link, useHistory, useParams } from "react-router-dom"
import { withRouter } from "react-router";

import apiResponse from '../../../../services/apiResponse'

import DetailBloc from './Blocs/DetailBloc'
import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar';
import moment from 'moment';

class IndexView extends Component {

    detailBloc = new DetailBloc()

    constructor(props) {
        super(props)
        this.state = {
            diklat: [],
            seminar: [],
            punishments: []
        }
    }

    dateParse = (input) =>{
        let res = "";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    componentDidMount() {
        this.detailBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response
                        this.setState({
                            detail: response.main,
                            diklat: response.diklat,
                            seminar: response.seminar,
                            punishments: response.punishment
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })
        const queryParams = new URLSearchParams(this.props.location.search)
        this.detailBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentWillUnmount() {
        this.detailBloc.detailChannel.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Detail Indeks Professionalitas</CardTitle>
                                    {/* <CardSubtitle className="mb-3">
                                        Informasi Detail Pengalaman Kerja Sebelum CPNS
                                    </CardSubtitle> */}
                                    <hr />
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            NIP
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_employee_nip !== "" ? this.state.detail.ip_employee_nip : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nama Pegawai
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_employee_name !== "" ? this.state.detail.ip_employee_name : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Jabatan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_employee_current_position_name !== "" ? this.state.detail.ip_employee_current_position_name : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Unit Kerja
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_employee_current_work_unit_name !== "" ? this.state.detail.ip_employee_current_work_unit_name : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nilai Kualifikasi
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_qualification_score !== "" ? this.state.detail.ip_qualification_score : '-'}</>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nilai Kompetensi
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_competition_score !== "" ? this.state.detail.ip_competition_score : '-'}</>
                                                : <Shimmer><div style={{width: '40%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nilai Kinerja
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_performance_score !== "" ? this.state.detail.ip_performance_score : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nilai Kedisiplinan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.ip_discipline_score !== "" ? this.state.detail.ip_discipline_score : '-'}</>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nilai Indeks Professionalitas 
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>
                                                        {this.state.detail.ip_score !== "" ? this.state.detail.ip_score : '-'}
                                                        {this.state.detail.ip_score_name !== "" ? ` (${this.state.detail.ip_score_name})` : '-'}
                                                    </>
                                                :
                                                    <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>

                                    <hr />
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            #Rincian Kualifikasi
                                            </label>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Pendidikan Terakhir
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.ip_last_education_name !== "" ? this.state.detail.ip_last_education_name : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                    <hr />
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            #Rincian Kompetensi
                                            </label>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Riwayat Diklat
                                            </label>
                                            <Col md="9">
                                                <Table className="table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            {/* <th>Jenis</th> */}
                                                            <th>Nama Diklat</th>
                                                            <th>Tempat</th>
                                                            <th>Penyelenggara</th>
                                                            <th>Tahun Diselenggarakan</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.diklat.length > 0 ? 

                                                                this.state.diklat.map((data, index) => {
                                                                    return (
                                                                        <tr>
                                                                            <td>{++index}</td>
                                                                            <td>{data.training_type_name}</td>
                                                                            <td>{data.training_place}</td>
                                                                            <td>{data.training_organizer}</td>
                                                                            <td>{data.training_year}</td>
                                                                        </tr>
                                                                    );
                                                                })

                                                            : 
                                                            <tr>
                                                                <td colSpan="5" className="text-center">Tidak Ada Data</td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Riwayat Kursus / Seminar / Workshop 
                                            </label>
                                            <Col md="9">
                                                <Table className="table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>Jenis</th>
                                                            <th>Nama</th>
                                                            <th>Tempat</th>
                                                            <th>Penyelenggara</th>
                                                            <th>Tanggal Mulai</th>
                                                            <th>Tanggal Selesai</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.seminar.length > 0 ? 

                                                                this.state.seminar.map((data, index) => {
                                                                    return (
                                                                        <tr>
                                                                            <td>{++index}</td>
                                                                            <td>{data.seminar_type_name}</td>
                                                                            <td>{data.seminar_name}</td>
                                                                            <td>{data.seminar_place}</td>
                                                                            <td>{data.seminar_organizer}</td>
                                                                            <td>{moment(data.seminar_start_date).format('DD/MM/YYYY')}</td>
                                                                            <td>{moment(data.seminar_end_date).format('DD/MM/YYYY')}</td>
                                                                        </tr>
                                                                    );
                                                                })

                                                            : 
                                                            <tr>
                                                                <td colSpan="7" className="text-center">Tidak Ada Data</td>
                                                            </tr>
                                                        }

                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    <hr />
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                #Rincian Kinerja
                                            </label>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Sasaran Kerja Pegawai
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.ip_employee_skp_score !== null ? this.state.detail.ip_employee_skp_score : '-'}</>
                                                    :
                                                        <Shimmer><div style={{width: '80%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                    <hr />
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                            #Rincian Disiplin
                                            </label>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Prilaku Kerja Pegawai
                                            </label>
                                            <Col md="9">
                                                <Table className="table-bordered table-striped">
                                                    <thead>
                                                        <tr>
                                                            <th>No</th>
                                                            <th>Nama Hukuman</th>
                                                            <th>Level Hukuman</th>
                                                            <th>Tanggal Hukuman</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            this.state.punishments.length > 0 ? 

                                                                this.state.punishments.map((data, index) => {
                                                                    return (
                                                                        <tr>
                                                                            <td>{++index}</td>
                                                                            <td>{data.punishment_category_name}</td>
                                                                            <td>{data.punishment_level}</td>
                                                                            <td>{this.dateParse(data.punishment_sk_date)}</td>
                                                                        </tr>
                                                                    );
                                                                })
                                                            : 
                                                            <tr>
                                                                <td colSpan="7" className="text-center">Tidak Ada Data</td>
                                                            </tr>
                                                        }
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </Row>
                                    <hr />

                                    <Row className="mb-3">
                                        <Col md="3"></Col>
                                        <Col md="9">
                                            <Link to="/kepegawaian/indeks_professionalitas.html?" className="waves-effect">
                                                <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                            </Link>
                                        </Col>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);